var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var mockAccountId = 'testAccount123';
export var mockAccountDetails = {
    accountInfo: {
        accountLast4: '4234',
        multiplePresentationInstruments: false
    },
    profile: {
        addressOnHold: false,
        'cipher.firstName': 'Jack Frost'
    },
    accountId: 'fe886e42-491f-4d15-b963-adb067a1f8d9',
    product: {
        clientId: 'lowes',
        displayName: "Lowe's® SetPay",
        lineOfBusiness: 'RETAIL_CARD',
        portfolio: "Lowe's SetPay",
        portfolioLogo: 'https://images.synchronycredit.com/assets/cardArt/syf_generic_card.svg',
        type: 'INSTALLMENT_LOAN'
    },
    card: {
        cardType: 'DUALCARD',
        cardArtURL: 'https://images.synchronycredit.com/assets/cardArt/syf_generic_card.svg',
        partnerId: '10199100119363216'
    },
    billing: {
        autopayEnrollment: true,
        customerAssistancePlan: true,
        daysDelinquent: '15',
        fixedPaymentAmount: '15.99',
        interestPaid: '34.87',
        lastPaymentAmount: '27.99',
        lastPaymentDate: '2020-03-19',
        nextPaymentDate: '2020-04-20',
        outstandingFeesAndCharges: '0',
        pastDue: false,
        pastDueAmount: '137.95',
        settlementEnrolled: false,
        statementBalance: '350.99',
        statementEnrollment: 'ELECTRONIC',
        totalMinimumPaymentDue: '0'
    },
    credit: {
        annualPercentageRate: '19.99',
        annualPercentageRateType: 'FIXED',
        availableCredit: '99.99',
        creditLimit: '8000',
        currentBalance: '248.44',
        temporaryCreditLimit: '1200'
    },
    installment: {
        principalAmount: '1000.99',
        monthlyAmountDue: '50.05',
        totalAmountPaid: '1000.99',
        startDate: '2020-03-20',
        endDate: '2021-03-20',
        interestRate: '27.99',
        loanTerm: '12',
        payoffValidThrough: '2020-03-20',
        purchaseAmount: '12.99',
        principalRemaining: '68.82',
        termRemaining: 1
    },
    rewards: {
        currency: 'DOLLARS',
        rewardsBalance: '300.99'
    },
    servicing: {
        allowable: false,
        reason: 'account.servicing.generic_restriction'
    },
    conditions: [],
    enrollments: []
};
export var sandboxMockAccounts = [
    __assign(__assign({}, mockAccountDetails), { accountId: '01ddf457-cd41-4d31-82f3-755df95d5ec0', accountInfo: {
            accountLast4: '3234',
            multiplePresentationInstruments: false
        }, card: {
            cardType: 'DUALCARD',
            cardArtURL: 'https://consumercenter.mysynchrony.com/cs/groups/public/documents/cc_images/img056283.png',
            partnerId: '10199100119363216'
        }, product: {
            clientId: 'amazon',
            displayName: 'Amazon Store Card',
            lineOfBusiness: 'RETAIL_CARD',
            portfolio: 'Home',
            portfolioLogo: 'https://images.synchronycredit.com/assets/synchrony/logo.svg',
            type: 'DUAL_CARD'
        } }),
    __assign(__assign({}, mockAccountDetails), { accountId: '12ggf689-jh41-4d56-89f5-755ws95k7fd1', accountInfo: {
            accountLast4: '0000',
            multiplePresentationInstruments: false
        }, card: {
            cardType: 'DUALCARD',
            cardArtURL: 'https://consumercenter.mysynchrony.com/cs/groups/public/documents/cc_images/img056283.png',
            partnerId: '10199100119363216'
        }, product: {
            clientId: 'PayLater',
            displayName: 'PayLater Store Card',
            lineOfBusiness: 'RETAIL_CARD',
            portfolio: 'Home',
            portfolioLogo: 'https://images.synchronycredit.com/assets/synchrony/logo.svg',
            type: 'INSTALLMENT_LOAN_MONTHLY'
        } }),
    mockAccountDetails
];
export var mockAccountWithRestrictedProductType = [
    __assign(__assign({}, mockAccountDetails), { product: {
            clientId: 'amazon',
            displayName: 'Amazon Store Card',
            lineOfBusiness: 'RETAIL_CARD',
            portfolio: 'Home',
            portfolioLogo: 'https://images.synchronycredit.com/assets/synchrony/logo.svg',
            type: 'INSTALLMENT_LOAN'
        } })
];
export var mockAccountsInfo = __spreadArray(__spreadArray([], mockAccountWithRestrictedProductType, true), [
    __assign(__assign({}, mockAccountDetails), { product: {
            clientId: 'Test',
            displayName: 'Test Name',
            lineOfBusiness: 'RETAIL_CARD',
            portfolio: 'Test Data',
            portfolioLogo: 'https://images.synchronycredit.com/assets/synchrony/logo.svg',
            type: 'INSTALLMENT_LOAN'
        } })
], false);
export var payLaterMockAccount = [
    __assign(__assign({}, mockAccountDetails), { product: {
            clientId: 'amazon',
            displayName: 'Amazon Store Card',
            lineOfBusiness: 'RETAIL_CARD',
            portfolio: 'Home',
            portfolioLogo: 'https://images.synchronycredit.com/assets/synchrony/logo.svg',
            type: 'INSTALLMENT_LOAN_MONTHLY'
        } })
];
